module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/branches/branches-show/branches-show.component.scss
// module id = ./src/app/views/setting/branches/branches-show/branches-show.component.scss
// module chunks = main